export default __webpack_public_path__ + "static/media/oluwaseun.d0c4180c.jpg";